// extracted by mini-css-extract-plugin
module.exports = {"boldText":"HeroText_boldText__2XlXC","link":"HeroText_link__1fLIf","text":"HeroText_text__2DP3k"};